module.exports = __webpack_public_path__ + "img/level1_idle_shadow.eeb45b57.png";